import React from "react";
import _ from "underscore";
import Nav from "react-bootstrap/Nav";
import {Button} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const QuickLinks = ({quick_links}) => {
    return (
        <div className="quicklinks">
            <Row>
                <Col>
                    <Row>
                        <Col>
                            <h2>Discover More</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Nav defaultActiveKey="/home" as="div">
                                {_.map(quick_links, (quick_link, idx) => {
                                    return (
                                        <Nav.Item
                                            key={idx}
                                            className="ql-b"
                                            href={quick_link.url}
                                            as={Button}
                                        >
                                            {quick_link.name}
                                        </Nav.Item>
                                    )
                                })}
                            </Nav>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    )
};

export default QuickLinks;